export enum Field {
  FirstName = 'firstName',
  LastName = 'lastName',
  Nationality = 'nationality',
  Birthday = 'birthday',
  BirthplaceCity = 'birthplaceCity',
  BirthplaceCountry = 'birthplaceCountry',
  Address = 'address',
}

export enum AddressField {
  CountryId = 'countryId',
  City = 'city',
  Line1 = 'line1',
  Line2 = 'line2',
  PostalCode = 'postalCode',
}
